export default __webpack_public_path__ + "static/logo-gray-svg-a2e5c00b3c6164348404895c1f3018e7.svg";